var styles = {"collapseButton":"styles_collapse-button__BKnIr","children":"styles_children__gD1Uq"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
